<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="update-ip-modal" tabindex="-1" role="dialog" aria-labelledby="ipModal">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">  Update IP plan of {{ domain }} </h5>
          </div>
          <div class="modal-body">
            <form @submit.prevent="update">
              <div class="row">
                <div class="col-md-12">
                  <label>New Server IP:</label>
                  <input type="text" required class="form-control h-43" placeholder="" :disabled="loading" v-model="ip" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button :disabled="loading" type="submit" class="btn btn-info btn-md d-inline pull-right">
                    <span v-if="loading">
                      <div class="loader" style="width: 15px;height: 15px; margin: 0.2rem 0 !important;"></div>
                    </span>
                    <span v-else>
                      Update
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";

export default {
  name: "updateIpModal",
  props: {
    docID: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      ip: null,
      loading: false,
      planIndex: null,
      domain: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.user;
    },
    custID() {
      return this.$store.getters["customer/id"];
    }
  },
  mounted () {
    $(".modal-backdrop").appendTo(".add-addon-domain-modal");
    $('.modal-backdrop').removeClass("modal-backdrop");
  },
  methods: {
    load (account) {
      $('#update-ip-modal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
      this.planIndex = account.planIndex;
      this.domain = account.domain;
    },
    async update () {
      this.loading = true;
      try {
        const resp = await this.$http.post('utilities/update-ip', {
          grant_type: "token",
          ip: this.ip,
          planIndex: this.planIndex,
          UID: this.docID,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          custId: this.custID,
          domain: this.domain
        });
        swal({
          title: "Updating",
          text: resp.data.msg,
          type: "success",
        });
        this.addLog({
          primaryPlan: this.domain,
          uid: this.docID,
          message: `User has Updated IP: ${this.ip}` ,
          level: "info"
        });
        this.ip = null;
        $('#update-ip-modal').modal('hide');
      } catch (e) {
        swal({
          title: "Error",
          text: "Something went wrong",
          type: "error",
        });

        this.addLog({
          uid: this.docID,
          message: `Error in updating ip, IP: ${this.ip}` ,
          level: "error"
        });
      }
      this.loading = false;

    }
  }
}
</script>

<style scoped>

</style>
